
export default {
  // Home page
  "airport_rankings": "Flughafen-Rangliste",
  "recent_reviews": "Aktuelle Bewertungen",
  "loading_reviews": "Bewertungen werden geladen...",
  "no_reviews": "Noch keine Bewertungen.",
  "share_experience": "Teilen Sie Ihre Erfahrung",
  "help_photographers": "Helfen Sie anderen Filmfotografen, indem Sie Ihre Erfahrungen an Flughäfen teilen",
  "add_review": "Bewertung hinzufügen",
  "loading_leaderboard": "Rangliste wird geladen...",
  "no_reviews_yet": "Noch keine Bewertungen",
  "be_first": "Seien Sie der Erste, der einen Flughafen bewertet!",
  "best_airports": "Beste Flughäfen",
  "worst_airports": "Schlechteste Flughäfen",
  "success_rate": "Erfolgsrate",
  "airport_name": "Flughafenname",
  "airport_location": "Standort",
  "score": "Bewertung",
  "total_reviews": "Bewertungen",
  "bottom_10_airports": "Die 10 schlechtesten Flughäfen basierend auf Filmfotografen-Bewertungen",
  "top_10_airports": "Die 10 besten Flughäfen basierend auf Filmfotografen-Bewertungen",
  // Review tabs
  "all_reviews": "Alle Bewertungen",
  "verified_reviews": "Verifizierte Bewertungen",
  "no_verified_reviews": "Noch keine verifizierten Bewertungen.",
  "creative_reviews": "Kreativ-Bewertungen",
  "traveler_reviews": "Reisenden-Bewertungen",
  "no_creative_reviews": "Noch keine Bewertungen von verifizierten Kreativen.",
  "no_traveler_reviews": "Noch keine Bewertungen von verifizierten Reisenden."
};
